import * as React from "react";
import { SVGProps } from "react";
const TickIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21.5} height={21.5} {...props}>
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      data-name="Component 6407 \u2013 90"
      transform="translate(.75 .75)"
    >
      <circle
        cx={10}
        cy={10}
        r={10}
        fill={props?.fill ?? "none"}
        stroke="#18b5b7"
        data-name="Ellipse 588"
      />
      <path
        fill="rgba(0,0,0,0)"
        stroke={props.stroke ?? "#d0d4db"}
        d="m5.715 10 2.857 2.857 5.714-5.714"
        data-name="Path 5122"
      />
    </g>
  </svg>
);
export default TickIcon;
